<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        xs12
      >
        <material-card
          title="CTQ Analyzer"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <!-- <v-icon
            :class="{'card-shrink-active-icon' : shrink_1}"
            @click="shrink_1=!shrink_1"
          >mdi-apple-keyboard-control</v-icon> -->
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout wrap>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1>
                  <v-autocomplete
                    v-model="summaryFactory"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryFactoryMenu"
                    label="Vendor"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryPartNum"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryPartNumMenu"
                    label="PART NUMBER"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryprocess"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryprocessMenu"
                    label="PROCESS"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                   </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1>
                  <v-autocomplete
                    v-model="summarystation"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summarystationMenu"
                    label="STATION"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryparametername"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryparameternameMenu"
                    label="PARAMETER NAME"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1>
                  <v-autocomplete
                    v-model="summaryperiodtype"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryperiodtypeMenu"
                    label="PERIOD TYPE"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                 <v-flex
                  flex-small
                  mt-3
                  xs12
                  lg2>
                  <v-menu
                    v-if="summaryperiodtype === 'month'"
                    v-model="summaryMonthMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryMonthPicker"
                      label="起始時間"
                      prepend-icon="event"
                      readonly
                    />
                    <v-date-picker
                      v-model="summaryMonthPicker"
                      :min="'2025-01'"
                      :max="monthPickerMax"
                      :color="theme==='dark'?'danger':'general'"
                      type="month"
                      no-title
                      scrollable
                    />
                  </v-menu>
                  <v-autocomplete
                    v-else
                    v-model="summaryDateStart"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="contentDateList"
                    label="起始時間"
                     class="v-text-field__slot"
                    persistent-hint
                    outlined>
                       <template v-slot:item="data">
                      <div
                        :class="{'weeks-list-data-tip':summaryDateList.indexOf(data.item.value)!==-1}"
                        class="v-list__tile__content">
                        <div class="v-list__tile__title">
                          {{ data.item.text }}
                        </div>
                      </div>
                    </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center
                >
                  <v-btn
                    v-if="shrink_1"
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doSubmit()"
                  >
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>分析
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex
        v-if="submit"
        flex_width_auto
        xs12>
        <material-card
          id="checkTable"
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          title="SPC-Chart"
          color="deep-orange"
          class="card-mix card-padding">

          <v-btn v-if="showDownLoadBtn"
            class="mix-btn black text-light"
            style="right: 8rem;"
            @click="downloadCSV()">
            <v-icon class="float-left mr-1">mdi-download</v-icon>下載Excel
          </v-btn>
        </material-card>
        <material-card
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          class="d-table-t0 no-data-left">
          <!-- <v-select
            v-model="pagination.rowsPerPage"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="rowsAmount"
            class="v-text-field__slot d-inline-block float-right ml-5"
            style="width: 90px;"
            persistent-hint
            outlined
          /> -->
          <v-data-table
            :headers="responseHeaders"
            :items="responseData"
            :pagination.sync="pagination.current"
            :rows-per-page-items="rowsAmount"
            :class="{ 'showList': checkTableShowList.length>0}"
            class="freeze-title height-row-3"
            multi-sort
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <tr>
                <td class="table-width-150" style="white-space: pre-line;"> {{ item.modelName ? item.modelName.replace(/,/g, '\n') : '' }}</td>
                <td class="table-width-185">{{ item.partNumber }}</td>
                <td class="table-width-150">{{ item.processName }}</td>
                <td class="table-width-150">{{ item.stationName }}</td>
                <td class="table-width-200">{{ item.testItemName }}</td>
                <td class="table-width-150">{{ item.typeName }}</td>
                <td class="table-width-125">{{ item.cpk }}</td>
                <td class="table-width-90">{{ item.level }}</td>
                <td class="table-width-100">{{ item.max }}</td>
                <td class="table-width-110">{{ item.min }}</td>
                <td class="table-width-300">
                  <v-btn
  class="mx-0 mr-3 font-weight-bold small"
  color="orange"
  @click="openctqplot(item.pk,item.statisticTestItemType)"
  router
>
  <v-icon class="mr-2">mdi-download</v-icon>
  正態分佈
</v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div
            v-if="pagination.current.rowsPerPage != -1"
            class="text-xs-center pt-2 d-inline-block"
            style="margin-left: 0px;width: calc(100% - 140px);">
            <v-pagination
              v-model="pagination.page"
              :length="pages"/>
          </div>
          <v-autocomplete
            v-if="pagination.current.rowsPerPage != -1"
            v-model="pagination.page"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="pageslist"
            class="v-text-field__slot d-inline-block float-right mr-0"
            style="width: 90px;"
            persistent-hint
            outlined
          />
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        PROCESSING 處理中
      </p>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import qs from 'qs'
// import Vue from 'vue'
// import VueC3 from 'vue-c3'
// import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'
// import WeekPicker from '@/components/module/datepicker/WeekPicker.vue'

export default {
  name: 'CTQAnalyzer',
  //   components: {
  //     WeekPicker
  //   },
  data () {
    return {
      startdate: '2018-04-01',
      highlightedDates: ['2025-02-10', '2025-02-14', '2024-02-20'],
      highlightedEndDates: ['2025-02-08', '2025-02-13', '2024-02-14'],
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      processingView: false,
      // summaryCaseName: '',
      // summaryDate: '',
      // summaryEMS: '',
      // summaryEMSpk: 0,
      // summaryRange: '5',
      // summaryItem: 'CPU_TEMP',
      summaryTableShowList: [],
      // nullDatetime: null,
      // datetime: new Date(),
      // datetimeString: '2019-01-01 12:00',
      // formattedDatetime: '09/01/2019 12:00',
      // textFieldProps: {
      //   appendIcon: 'event'
      // },
      // dateProps: {
      //   headerColor: 'red'
      // },
      // timeProps: {
      //   useSeconds: false,
      //   ampmInTitle: true,
      //   format: '24hr',
      //   allowedMinutes: m => m % 30 === 0
      // },
      showBrightness: true,
      shrink_1: true,
      summaryRangeStartDateMenu: false,
      summaryRangeStartDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryRangeEndDateMenu: false,
      summaryRangeEndDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryFactoryMenu: [],
      summaryFactory: '',
      tempFactory: '',
      summaryPartNumMenu: [],
      summaryPartNum: '',
      tempPartNum: '',
      summaryprocessMenu: [],
      summaryprocess: '',
      tempprocess: '',
      summarystationMenu: [],
      summarystation: '',
      tempstation: '',
      summaryparameternameMenu: [],
      summaryparametername: '',
      tempparametername: '',
      summaryperiodtypeMenu: [],
      summaryperiodtype: '',
      tempperiodtype: '',
      summarystageMenu: ['NPI', 'MP'],
      summarystage: '',
      contentDateList: [],
      summaryDateList: [],
      summaryDateStart: '',
      summaryMonthMenu: false,
      showDownLoadBtn: true,
      // biosSn: '',
      // i1Sn: '',
      // mfrid: '',
      // mfrdate: '',
      // errorCode: '',
      // yRangeType: '',
      // yRangeStart: '',
      // yRangeEnd: '',
      // xyCoordinateRangeType: '',
      // xCoordinateRangeStart: '',
      // xCoordinateRangeEnd: '',
      // yCoordinateRangeStart: '',
      // yCoordinateRangeEnd: '',
      // gammaRangeStart: '',
      // gammaRangeEnd: '',
      // gammaDiffRangeStart: '',
      // gammaDiffRangeEnd: '',
      summary: {
        biosSn: '',
        i1Sn: '',
        mfrid: '',
        mfrdate: '',
        errorCode: '',
        yRangeType: '',
        yRangeStart: '',
        yRangeEnd: '',
        xyCoordinateRangeType: '',
        xCoordinateRangeStart: '',
        xCoordinateRangeEnd: '',
        yCoordinateRangeStart: '',
        yCoordinateRangeEnd: '',
        gammaRangeStart: '',
        gammaRangeEnd: '',
        gammaDiffRangeStart: '',
        gammaDiffRangeEnd: ''
      },
      // RangeAll: true,
      // RangeIndex: 999,
      // RangeMin: 0,
      // RangeMax: 9999,
      // RangeMaxList: {
      //   CPU_TEMP: 200,
      //   GPU_TEMP: 200,
      //   CPU_POWER: 200,
      //   GPU_POWER: 200
      // },
      // OverRangeCount: 0,
      // RangeCount: 1,
      passAmount: '0',
      failAmount: '0',
      totalTestInputs: '0',
      submit: false,
      IsSubmitPage: true,
      isSorting: false,
      responseData: [],
      responseDataOnly: [],
      checkTableInputDefine: [
        { text: 'MeasureLoop', value: 'measureLoop' },
        { text: 'Validation0', value: 'validationType0' },
        { text: 'Validation1', value: 'validationType1' },
        { text: 'WriteBIOS', value: 'writeBios' },
        { text: 'PanelIndex', value: 'panelIndex' },
        { text: 'Luminance of White', value: 'luminanceOfWhite' },
        { text: 'Luminance of Black', value: 'luminanceOfBlack' },
        { text: 'Luminance of Red', value: 'luminanceOfRed' },
        { text: 'Luminance of Green', value: 'luminanceOfGreen' },
        { text: 'Luminance of Blue', value: 'luminanceOfBlue' },
        { text: 'CalibrationWY', value: 'calibratedWy' },
        { text: 'CalibratedGamma', value: 'calibratedGamma' },
        { text: 'Gamma', value: 'gamma' },
        { text: 'GammaL', value: 'gammaLow' },
        { text: 'GammaH', value: 'gammaHigh' },
        { text: 'Gamma_Diff', value: 'gammaDiff' },
        { text: 'Contrast', value: 'contrast' },
        { text: 'R/G/B/W', value: 'assignColor' },
        { text: 'x of coordinate', value: 'xcoordinate' },
        { text: 'y of coordinate', value: 'ycoordinate' },
        { text: 'ProjectTargetWx', value: 'projectTargetWx' },
        { text: 'ProjectTargetWy', value: 'projectTargetWy' },
        { text: 'ProjectYLimit', value: 'projectYLimit' },
        { text: 'ImprovedTargetWx', value: 'improvedTargetWx' },
        { text: 'ImprovedTargetWy', value: 'improvedTargetWy' },
        { text: 'PredImprovedTargetWx', value: 'predictImprovedTargetWx' },
        { text: 'PredImprovedTargetWy', value: 'predictImprovedTargetWy' },
        { text: 'MeasImprovedTargetWx', value: 'measureImprovedTargetWx' },
        { text: 'MeasImprovedTargetWy', value: 'measureImprovedTargetWy' },
        { text: 'MeasImprovedTargetWY', value: 'measureImprovedTargetWYY' },
        { text: 'FinalTargetWx', value: 'finalTargetWx' },
        { text: 'FinalTargetWy', value: 'finalTargetWy' },
        { text: 'FinalWx', value: 'finalWx' },
        { text: 'FinalWy', value: 'finalWy' },
        { text: 'FinalWY', value: 'finalWYY' },
        { text: 'CalibratedWhiteDistanceFail', value: 'calibratedWhiteDistanceFail' },
        { text: 'DeltaE_ScoreAvg', value: 'deltaEScoreAvg' },
        { text: 'DeltaE_Score', value: 'deltaEScore' },
        { text: 'CCT', value: 'cct' },
        { text: 'CCT_Gamma', value: 'cctGamma' },
        { text: 'BiosString', value: 'biosString' },
        { text: 'X/Y/Z Info', value: 'xyzInfo' }],
      responseColumnDefine: [
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Model',
          value: 'modelName'
        },
        {
          align: '',
          class: 'table-width-185',
          fixed: true,
          sortable: true,
          text: 'PartNumber',
          value: 'partNumber'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Process',
          value: 'processName'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Station',
          value: 'stationName'
        },
        {
          align: '',
          class: 'table-width-200',
          fixed: true,
          sortable: true,
          text: 'ParameterName',
          value: 'testItemName'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'Type',
          value: 'typeName'
        },
        {
          align: '',
          class: 'table-width-125',
          fixed: true,
          sortable: true,
          text: 'CPK',
          value: 'cpk'
        },
        {
          align: '',
          class: 'table-width-90',
          fixed: true,
          sortable: true,
          text: 'Level',
          value: 'level'
        },
        {
          align: '',
          class: 'table-width-100',
          fixed: true,
          sortable: true,
          text: 'Max',
          value: 'max'
        },
        {
          align: '',
          class: 'table-width-110',
          fixed: true,
          sortable: true,
          text: 'Min',
          value: 'min'
        }
      ],
      responseHeaders: [],
      responseHeadersOnly: [],
      responseHeadersList: [],
      responseColumnClassList: {},
      responseAlignList: {},
      responseTableShowList: {},
      responseTableShowListOnly: {},
      responseAreaData: {
        commonFailQty: 0,
        commonFailRate: 0,
        failQty: 0,
        failRate: 0,
        fanErrorCodeList: [],
        fanFailQty: 0,
        fanFailRate: 0,
        noDefineFailQty: 0,
        passQty: 0,
        passRate: 0,
        productionQty: 0,
        thermalFailQty: 0,
        thermalFailRate: 0,
        warningColor: 'green'
      },
      checkList: [],
      checkTableShowList: [],
      modelnameList: [],
      // lineXaxisName: [],
      // lineXaxisValue: [],
      rowsAmount: [10, 25, 50, 100],
      pagination: {
        page: 1,
        current: {
          descending: null,
          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          totalItems: 0
        }
      },
      pages: 1,
      isInitialPageLoad: true
      // handler_bar: new Vue()
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    monthPickerMax () {
      const t = new Date()
      const m = t.getMonth() + 1
      return t.getFullYear() + '-' + (m < 10 ? '0' + m : String(m))
    },
    summaryMonthPicker: {
      get () {
        const v = this.summaryDateStart
        const matched = String(v || '').match(/^(\d{4})M(\d{2})$/)
        return matched ? (matched[1] + '-' + matched[2]) : ''
      },
      set (val) {
        if (val && /^\d{4}-\d{2}$/.test(val)) {
          this.summaryDateStart = val.replace('-', 'M')
        } else {
          this.summaryDateStart = val || ''
        }
      }
    }
    // options_bar () {
    //   return {
    //     data: {
    //       x: 'x',
    //       columns: [
    //         this.barXaxisName,
    //         this.barXaxisValue
    //       ],
    //       labels: true,
    //       // labels: {
    //       //   // format: function (v, id, i, j) { return v + '%' }
    //       // },
    //       // onclick: function (d) { alert(d.index) },
    //       onclick: (d) => { this.summaryList(d.index, 'range') },
    //       type: 'bar',
    //       types: {
    //         'NormalDistribution': 'spline'
    //       },
    //       axes: {
    //         'ModelName': 'y'
    //       }
    //       // colors: {
    //       //   ModelName: '#999999'
    //       // }
    //       // onclick: (d, i) => { this.summaryList(d, i) } // {id: "data23", value: 120, ratio: 0.8, index: 1, name: "data23"}
    //       // color: function (color, d) {
    //       //   // d will be 'id' when called for legends
    //       //   return d.value >= 5.0 ? '#ff0000' : d.value >= 3.0 ? '#ff9800' : color
    //       // }
    //       // color: (color, d) => {
    //       //   // d will be 'id' when called for legends
    //       //   return (this.OverRangeCount > 0 && d.index === this.barXaxisName.length - 2) ? '#ffa500' : color
    //       // }
    //     },
    //     axis: {
    //       x: {
    //         type: 'category', // this needed to load string x value
    //         tick: {
    //           rotate: -45,
    //           multiline: false
    //         }
    //         // label: {
    //         //   text: '期',
    //         //   position: 'outer-center'
    //         // }
    //       },
    //       y: {
    //         // max: this.RangeCount,
    //         // min: 0,
    //         // tick: {
    //         //   // count: this.RangeCount + 1
    //         // },
    //         // padding: {
    //         //   top: 0,
    //         //   bottom: 0
    //         // }
    //         // tick: {
    //         //   format: function (value) { return value + '%' }
    //         // }
    //         // label: {
    //         //   text: '%',
    //         //   position: 'outer-middle'
    //         // }
    //       },
    //       y2: {
    //         // show: true
    //         // label: {
    //         //   text: '億',
    //         //   position: 'outer-middle'
    //         // }
    //       }
    //     },
    //     tooltip: {
    //       format: {
    //         title (d) {
    //           // return `第 ${d} 期`
    //         },
    //         value (value, ratio, id) {
    //           // return `${value} 億`
    //         }
    //       }
    //     },
    //     grid: {
    //       x: {
    //         show: true
    //       },
    //       y: {
    //         show: true
    //       }
    //     },
    //     legend: {
    //       position: 'bottom',
    //       padding: 16,
    //       show: false
    //     },
    //     size: {
    //       // width: 640,
    //       height: 500
    //     }
    //   }
    // }
  },
  watch: {
    summaryFactory (val) {
      // this.summaryPartNumMenu = [
      //   { text: 'Test123_UX5406ZA', value: 'Test123_UX5406ZA' },
      //   { text: 'Test456_X515EA', value: 'Test456_X515EA' }
      // ]
      // this.summaryprocess = ''
      // this.summarystation = ''
      // this.summarystation = ''
      // this.summaryperiodtype = ''
      // if (this.tempPartNum !== '' && this.isInitialPageLoad) {
      //   this.summaryPartNum = this.tempPartNum
      // }
      const body = {
        vendorCode: this.summaryFactory
      }
      this.$http.get('/api/ctq/part/model/getPartNumberByVendorCode?' + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            const data = res.data
            this.summaryPartNumMenu = data.map(item => ({
              text: item.partNumber + ' (' + item.modelName + ')',
              value: item.partNumber
            }))
            this.summaryprocess = ''
            this.summarystation = ''
            this.summarystation = ''
            this.summaryperiodtype = ''
            if (this.tempPartNum !== '' && this.isInitialPageLoad) {
              this.summaryPartNum = this.tempPartNum
            }
          }
        })
    },
    summaryPartNum (val) {
      const body = {
        vendorCode: this.summaryFactory,
        partNumber: val
      }
      this.$http.get(`/api/ctq/test/spec/getProcess?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            const data = res.data
            this.summaryprocessMenu = data.map(item => ({
              text: item.processName,
              value: item.processCode
            }))
            this.summarystation = ''
            this.summaryparametername = ''
            this.summaryperiodtype = ''
            if (this.tempprocess !== '' && this.isInitialPageLoad) {
              this.summaryprocess = this.tempprocess
            }
          }
        })
      // this.summaryprocessMenu = [
      //   { text: 'Forming', value: 'Forming' },
      //   { text: 'Stamping', value: 'Stamping' },
      //   { text: 'CNC', value: 'CNC' },
      //   { text: 'Sandblasting', value: 'Sandblasting' },
      //   { text: 'Anodizing', value: 'Anodizing' },
      //   { text: 'MAO', value: 'MAO' },
      //   { text: 'Assembly', value: 'Assembly' },
      //   { text: 'Polisning', value: 'Polisning' },
      //   { text: 'Painting', value: 'Painting' }
      // ]
      // this.summarystation = ''
      // this.summaryparametername = ''
      // this.summaryperiodtype = ''
      // if (this.tempprocess !== '' && this.isInitialPageLoad) {
      //   this.summaryprocess = this.tempprocess
      // }
    },
    summaryprocess (val) {
      const body = {
        vendorCode: this.summaryFactory,
        partNumber: this.summaryPartNum,
        processCode: val
      }
      this.$http.get(`/api/ctq/test/spec/getStation?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            const data = res.data
            this.summarystationMenu = data.map(item => ({
              text: item.stationName,
              value: item.stationCode
            }))
            this.summaryparametername = ''
            this.summaryperiodtype = ''
            if (this.tempstation !== '' && this.isInitialPageLoad) {
              this.summarystation = this.tempstation
            }
          }
        })
      // this.summarystationMenu = [
      //   { text: '印刷工站', value: '印刷工站' },
      //   { text: '噴精油', value: '噴精油' },
      //   { text: '上掛', value: '上掛' },
      //   { text: '陽極槽', value: '陽極槽' },
      //   { text: '染色槽', value: '染色槽' },
      //   { text: '下掛', value: '下掛' },
      //   { text: '封孔槽', value: '封孔槽' },
      //   { text: 'P尺寸量測', value: 'P尺寸量測' },
      //   { text: '公模噴砂站', value: '公模噴砂站' }
      // ]
      // this.summaryparametername = ''
      // this.summaryperiodtype = ''
      // if (this.tempstation !== '' && this.isInitialPageLoad) {
      //   this.summarystation = this.tempstation
      // }
    },
    summarystation (val) {
      const body = {
        vendorCode: this.summaryFactory,
        partNumber: this.summaryPartNum,
        processCode: this.summaryprocess,
        stationCode: val
      }
      this.$http.get(`/api/ctq/test/spec/getTestItem?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            const data = res.data
            this.summaryparameternameMenu = data.map(item => ({
              text: item.testItemName,
              value: item.testItemCode
            }))
            if (this.tempparametername !== '' && this.isInitialPageLoad) {
              this.summaryparametername = this.tempparametername
            }
            if (this.isInitialPageLoad) {
              this.isInitialPageLoad = false
            }
          }
        })
      // this.summaryparameternameMenu = [
      //   { text: '功率', value: '功率' },
      //   { text: '阻抗', value: '阻抗' },
      //   { text: '溫度', value: '溫度' },
      //   { text: '功率', value: '功率' },
      //   { text: '壓力', value: '壓力' },
      //   { text: '長邊尺寸', value: '長邊尺寸' },
      //   { text: '寬邊尺寸', value: '寬邊尺寸' },
      //   { text: '掛具彈力', value: '掛具彈力' },
      //   { text: 'PH', value: 'PH' }
      // ]
      // if (this.tempparametername !== '' && this.isInitialPageLoad) {
      //   this.summaryparametername = this.tempparametername
      // }
      // if (this.isInitialPageLoad) {
      //   this.isInitialPageLoad = false
      // }
    },
    summaryMonthPicker () {
      this.summaryMonthMenu = false
    },
    summaryperiodtype (val) {
      const result = []
      const today = new Date()
      const currentYear = today.getFullYear()
      const startYear = 2025

      const pad = (n) => String(n).padStart(2, '0')

      // ================= YEAR =================
      if (val === 'year') {
        for (let y = currentYear; y >= startYear; y--) {
          result.push({
            text: `${y}`,
            value: `${y}`
          })
        }
      }

      // ================= MONTH =================
      if (val === 'month') {
        for (let y = currentYear; y >= startYear; y--) {
          let maxMonth = 12

          // 當前年只到當月
          if (y === currentYear) {
            maxMonth = today.getMonth() + 1
          }

          for (let m = maxMonth; m >= 1; m--) {
            result.push({
              text: `${y}-${pad(m)}`,
              value: `${y}M${pad(m)}`
            })
          }
        }
      }

      // ================= SEASON (季度) =================
      if (val === 'season') {
        const seasons = [
          { s: 'Q1', start: '01-01', end: '03-31', startMonth: 1 },
          { s: 'Q2', start: '04-01', end: '06-30', startMonth: 4 },
          { s: 'Q3', start: '07-01', end: '09-30', startMonth: 7 },
          { s: 'Q4', start: '10-01', end: '12-31', startMonth: 10 }
        ]

        for (let y = currentYear; y >= startYear; y--) {
          for (let i = 3; i >= 0; i--) {
            const item = seasons[i]

            // 季度開始日期
            const seasonStart = new Date(y, item.startMonth - 1, 1)

            // 未開始季度不顯示
            if (seasonStart > today) continue

            result.push({
              text: `${y} ${item.s} (${item.start} ~ ${item.end})`,
              value: `${y}S0${i + 1}`
            })
          }
        }
      }

      // ================= WEEK =================
      if (val === 'week') {
        const format = (d) =>
          `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

        const getWeekStart = (date) => {
          const d = new Date(date)
          const day = d.getDay() || 7 // Sunday=7
          if (day !== 1) {
            d.setDate(d.getDate() - day + 1)
          }
          d.setHours(0, 0, 0, 0)
          return d
        }

        const getWeekEnd = (start) => {
          const end = new Date(start)
          end.setDate(start.getDate() + 6)
          return end
        }

        // 判断跨年归属（哪年天多算哪年）
        const getWeekYear = (start, end) => {
          const count = {}

          for (let i = 0; i < 7; i++) {
            const d = new Date(start)
            d.setDate(start.getDate() + i)
            const y = d.getFullYear()
            count[y] = (count[y] || 0) + 1
          }

          return Object.keys(count).reduce((a, b) =>
            count[a] > count[b] ? a : b
          )
        }

        const weekMap = {}

        let cursor = getWeekStart(new Date(startYear, 0, 1))

        // ================= 用 FOR 循环替代 WHILE =================
        for (; cursor <= today;) {
          const start = new Date(cursor)
          const end = getWeekEnd(start)

          const belongYear = getWeekYear(start, end)

          if (!weekMap[belongYear]) {
            weekMap[belongYear] = 1
          } else {
            weekMap[belongYear]++
          }

          const weekNo = weekMap[belongYear]

          result.push({
            text: `${belongYear} W${pad(weekNo)} (${format(start)} ~ ${format(end)})`,
            value: `${belongYear}W${pad(weekNo)}`
          })

          cursor = new Date(cursor)
          cursor.setDate(cursor.getDate() + 7)
        }

        result.reverse()
      }

      this.contentDateList = result
      this.summaryDateStart = ''
      const body = {
        vendorCode: this.summaryFactory,
        partNumber: this.summaryPartNum,
        processCode: this.summaryprocess,
        stationCode: this.summarystation,
        testItemCode: this.summaryparametername,
        statisticTimeType: val
      }
      this.$http.post(`/api/ctq/test/statistic/getStatisticTime4HaveData`, body).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryDateList = res.data
          }
        })
    },
    summaryRangeStartDate (val) {
      this.summaryRangeStartDateMenu = false
      // this.startTimeMenu = true
    },
    // startTime (val) {
    //   if (this.startTimeMenuOperating > 0) {
    //     this.startTimeMenuOperating = 0
    //     this.startTimeMenu = false
    //   } else {
    //     this.startTimeMenuOperating = this.startTimeMenuOperating + 1
    //   }
    // },
    // startTimeMenu (val) {
    //   if (!val) {
    //     this.startTimeMenuOperating = 0
    //   }
    // },
    summaryRangeEndDate (val) {
      this.summaryRangeEndDateMenu = false
      // this.endTimeMenu = true
    },
    // endTime (val) {
    //   if (this.endTimeMenuOperating > 0) {
    //     this.endTimeMenuOperating = 0
    //     this.endTimeMenu = false
    //   } else {
    //     this.endTimeMenuOperating = this.endTimeMenuOperating + 1
    //   }
    // },
    // endTimeMenu (val) {
    //   if (!val) {
    //     this.endTimeMenuOperating = 0
    //   }
    // },
    checkTableShowList (val) {
      this.responseHeaders = JSON.parse(JSON.stringify(this.responseHeadersOnly))
      this.responseTableShowList = JSON.parse(JSON.stringify(this.responseTableShowListOnly))

      this.summaryTableShowList.forEach((s, index) => {
        this.checkTableShowList.forEach((c) => {
          this.responseTableShowList[c] = true
          if (s.value === c) {
            this.responseHeaders.push(this.responseHeadersList[index])
          }
        })
      })
    },
    // responseData (val) {
    //   this.pages = Math.ceil(this.totalRows / this.pagination.rowsPerPage)
    //   if (this.pages > 1) {
    //     setTimeout(() => {
    //       this.pagination.page = this.pages
    //     }, 0)
    //     setTimeout(() => {
    //       this.pagination.page = 1
    //     }, 100)
    //   } else {
    //     setTimeout(() => {
    //       this.pagination.rowsPerPage = 1
    //     }, 0)
    //     setTimeout(() => {
    //       this.pagination.rowsPerPage = this.perPageRows
    //     }, 100)
    //   }
    // },
    // perPageRows (val) {
    //   if (val === -1) {
    //     if (confirm('完整顯示將可能導致效能降低，是否仍完整顯示?')) {
    //       this.pagination.rowsPerPage = val
    //       this.pages = Math.ceil(this.responseData.length / this.pagination.rowsPerPage)
    //       this.pagination.page = 1
    //     } else {
    //       setTimeout(() => {
    //         this.perPageRows = this.pagination.rowsPerPage
    //       }, 100)
    //     }
    //   } else {
    //     this.pagination.rowsPerPage = val
    //     this.pages = Math.ceil(this.responseData.length / this.pagination.rowsPerPage)
    //     this.pagination.page = 1
    //   }
    // },
    'pagination.current.sortBy' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        // 让排序锁在本次事件循环后释放
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.current.descending' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.page': {
      handler (newName, oldName) {
        if (this.isSorting) return
        if (this.submit && !this.IsSubmitPage) {
          this.doCTQDataList()
        }
      },
      immediate: true,
      deep: true
    },
    'pagination.current.rowsPerPage': {
      handler (newName, oldName) {
        if (this.isSorting) return
        if (this.submit && !this.IsSubmitPage) {
          this.doCTQDataList()
        }
      },
      immediate: true,
      deep: true
    }
    // 'pagination.page' (val) {
    //   this.checkList = []
    // },
    // 'pagination.rowsPerPage' (val) {
    //   this.checkList = []
    // },
    // 'pagination.sortBy' (val) {
    //   this.checkList = []
    // },
    // 'pagination.descending' (val) {
    //   this.checkList = []
    // }
    // summaryDate (val) {
    //   this.summaryDateMenu = false
    // },
    // summaryItem (val) {
    //   this.doSummary()
    // },
    // summaryRange (val) {
    //   this.doSummary()
    // }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/ctq/CTQAnalyzer')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          if (this.$route.params.factory && this.$route.params.project && this.$route.params.process && this.$route.params.station && this.$route.params.parametername && this.$route.params.periodtype && !this.isPageReload()) {
            this.tempFactory = Number(this.$route.params.factory)
            this.tempPartNum = this.$route.params.project
            this.tempprocess = this.$route.params.process
            this.tempstation = this.$route.params.station
            this.tempparametername = this.$route.params.parametername
            this.tempperiodtype = this.$route.params.periodtype
          }
          sessionStorage.removeItem('cacheFilterInfo')
          const body = {
            type: 'mepart'
          }
          this.$http.get('/api/system/pmsPath/getCodeAndNameListByType?' + qs.stringify(body)).then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                const data = res.data
                this.summaryFactoryMenu = data.map(item => ({
                  text: item.name,
                  value: item.code
                }))
                if (this.tempFactory !== '') {
                  this.summaryFactory = this.tempFactory
                }
              }
            })
          // this.doResponseColumnDefine()
          // this.summaryFactoryMenu = [
          //   { text: 'JT_NJ', value: '00' },
          //   { text: 'DCB-CQ', value: '01' },
          //   { text: 'MOGOLD-SZ', value: '02' },
          //   { text: 'YUCHIA-NT', value: '03' },
          //   { text: 'CTC-KS', value: '04' },
          //   { text: 'VITO-SQ', value: '05' }
          // ]
          this.summaryperiodtypeMenu = [
            { text: '年', value: 'year' },
            { text: '季', value: 'season' },
            { text: '月', value: 'month' },
            { text: '周', value: 'week' }
          ]
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    openctqplot (pk, statisticTestItemType) {
      const routeData = this.$router.resolve({
        path: '/ctq/CTQAnalyzer/ShowCTQNormaldistributionplot',
        query: {
          pk,
          statisticTestItemType
        }
      })

      window.open(routeData.href, '_blank')
    },
    selectedDate (val) {
      this.summaryDateStart = val
    },
    isPageReload () {
      if (performance.getEntriesByType && performance.getEntriesByType('navigation').length > 0) {
        return performance.getEntriesByType('navigation')[0].type === 'reload'
      } else if (performance.navigation) {
        return performance.navigation.type === 1
      }
      return false
    },
    getEventColor (date) {
      return this.highlightedDates.includes(date) ? 'green' : ''// 蓝色小圆点
    },
    getEndEventColor (date) {
      return this.highlightedEndDates.includes(date) ? 'green' : ''// 蓝色小圆点
    },
    doResponseColumnDefine () {
      // this.responseHeaders.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      // this.responseHeadersOnly.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      console.log('responseColumnDefine:', this.responseColumnDefine)
      console.log('responseTableShowListOnly:', this.responseTableShowListOnly)
      this.responseHeadersList = []
      this.responseHeaders = []
      this.responseHeadersOnly = []
      this.responseTableShowList = {}
      this.responseTableShowListOnly = {}
      this.responseColumnClassList = {}
      this.responseAlignList = {}
      this.summaryTableShowList = []
      this.responseColumnDefine.forEach((r) => {
        if (r.fixed) {
          this.responseHeaders.push(r)
          this.responseHeadersOnly.push(r)
        } else {
          this.responseHeadersList.push(r)
          this.responseTableShowList[r.value] = r.fixed
          this.responseTableShowListOnly[r.value] = r.fixed
          this.responseColumnClassList[r.value] = r.class
          this.responseAlignList[r.value] = r.align
          this.summaryTableShowList.push({ text: r.text, value: r.value })
        }
      })
      console.log('responseHeaders:', this.responseHeaders)
      console.log('responseTableShowList:', this.responseTableShowList)
      console.log('responseTableShowListOnly:', this.responseTableShowListOnly)
    },
    // doBeforeLink (TtrsPk, deviceSn) {
    //   this.$http.post('/api/thermal/getSingleDeviceBurnInDataStatistic?ttrsPk=' + TtrsPk).then(res => res.data)
    //     .then(res => {
    //       if (res.status === 'success') {
    //         let Groups = res.data.fanTestData.length
    //         const routeData = this.$router.resolve({ path: '/thermal/singleDeviceBurnInDataStatistic/' + TtrsPk + '/' + Groups, query: { sn: deviceSn, modelname: this.summaryCaseName, date: this.summaryDate, ems: this.summaryEMS } })
    //         window.open(routeData.href, '_blank')
    //       }
    //     })
    // },
    // doSummary (type) {
    //   this.barXaxisName = ['x']
    //   this.barXaxisValue = ['ModelName']
    //   let AllArray = []
    //   this.responseDataOnly.forEach((r) => {
    //     if (r[this.summaryItem] >= 0) {
    //       AllArray.push(r[this.summaryItem])
    //     }
    //   })
    //   this.RangeMax = Math.ceil(Math.max(...AllArray) / this.summaryRange) * this.summaryRange
    //   this.RangeMin = Math.floor(Math.min(...AllArray) / this.summaryRange) * this.summaryRange
    //   if (this.RangeMax > this.RangeMaxList[this.summaryItem]) {
    //     this.RangeMax = Math.min(this.RangeMax, this.RangeMaxList[this.summaryItem])
    //   }
    //   this.OverRangeCount = 0
    //   const RangeArray = []
    //   for (let i = this.RangeMin; i < this.RangeMax; i = i + this.summaryRange) {
    //     RangeArray[(i - this.RangeMin) / this.summaryRange] = 0
    //   }
    //   AllArray.forEach((r) => {
    //     if (r > this.RangeMaxList[this.summaryItem]) {
    //       this.OverRangeCount = this.OverRangeCount + 1
    //     } else {
    //       if (RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] > 0) {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] + 1
    //       } else {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = 1
    //       }
    //     }
    //   })

    //   this.RangeCount = Math.max(...RangeArray)
    //   for (let i = 0; i < RangeArray.length; i++) {
    //     this.barXaxisValue.push(RangeArray[i] || 0)
    //     switch (true) {
    //       case (this.summaryRange === '5' || this.summaryRange === '10'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(0) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(0))
    //         break
    //       case (this.summaryRange === '2.5' || this.summaryRange === '7.5'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(1) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(1))
    //         break
    //       // default:
    //       // return
    //     }
    //   }
    //   if (this.OverRangeCount > 0) {
    //     this.barXaxisValue.push(this.OverRangeCount)
    //     this.barXaxisName.push('>' + this.RangeMaxList[this.summaryItem])
    //   }
    //   // RangeArray.forEach((r, index) => {
    //   //   console.log(r)
    //   //   console.log(index)
    //   //   this.barXaxisValue.push(r)
    //   //   this.barXaxisName.push((this.RangeMin + (index * this.summaryRange)) + '-' + (this.RangeMin + ((index + 1) * this.summaryRange)))
    //   // })
    //   if (type === 'init') {
    //     this.handler_bar.$emit('init', this.options_bar)
    //   } else {
    //     this.handler_bar.$emit('dispatch', chart => {
    //       const options = {
    //         columns: [
    //           this.barXaxisName,
    //           this.barXaxisValue
    //         ]
    //       }
    //       chart.load(options)
    //     })
    //   }
    // },
    checkTableShowListAll () {
      this.checkTableShowList = []
      this.summaryTableShowList.forEach((s) => {
        this.checkTableShowList.push(s.value)
      })
    },
    checkTableShowListClear () {
      this.checkTableShowList = []
    },
    doSubmit () {
      if (this.doSubmitVerification()) {
        this.loadingView = true
        this.pagination.page = 1
        this.pagination.current.rowsPerPage = 25
        if (this.summaryperiodtype === 'year' || this.summaryperiodtype === 'season') {
          this.showDownLoadBtn = false
        } else {
          this.showDownLoadBtn = true
        }
        this.doCTQDataList()
        // setTimeout(() => {
        //   this.loadingView = false
        // }, 0)
        const Url = '/ctq/CTQAnalyzer/' + this.summaryFactory + '/' + this.summaryPartNum + '/' + this.summaryprocess + '/' + this.summarystation + '/' + this.summaryparametername + '/' + this.summaryperiodtype
        if (this.$router.history.current.path !== Url) {
          this.$router.replace(Url)
        }
        // Object.keys(this.summary).forEach(key => {
        //   this.summary[key] = ''
        // })
      }
    },
    doSubmitVerification () {
      if (this.summaryFactory === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Vendor'
        return false
      } else if (this.summaryPartNum === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇PART NUMBER'
        return false
      } else if (this.summaryprocess === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Process'
        return false
      } else if (this.summarystation === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Station'
        return false
      } else if (this.summaryparametername === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Parameter Name'
        return false
      } else if (this.summaryperiodtype === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Period Type'
        return false
      } else if (this.summaryDateStart === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇時間'
        return false
      } else {
        return true
      }
    },
    doCTQSaveFilterInfo () {
      const body = {
        vendorCode: this.summaryFactory,
        factoryName: this.summaryFactoryMenu[this.summaryFactoryMenu.map(e => { return e.value }).indexOf(this.summaryFactory)].text || null,
        partNumber: this.summaryPartNum,
        processCode: this.summaryprocess,
        process: this.summaryprocessMenu[this.summaryprocessMenu.map(e => { return e.value }).indexOf(this.summaryprocess)].text || null,
        stationCode: this.summarystation,
        station: this.summarystationMenu[this.summarystationMenu.map(e => { return e.value }).indexOf(this.summarystation)].text || null,
        testItemCode: this.summaryparametername,
        parametername: this.summaryparameternameMenu[this.summaryparameternameMenu.map(e => { return e.value }).indexOf(this.summaryparametername)].text || null,
        statisticTimeType: this.summaryperiodtype,
        periodtype: this.summaryperiodtypeMenu[this.summaryperiodtypeMenu.map(e => { return e.value }).indexOf(this.summaryperiodtype)].text || null,
        statisticTimeValue: this.summaryDateStart,
        searchdate: this.contentDateList[this.contentDateList.map(e => { return e.value }).indexOf(this.summaryDateStart)].text || null,
        project: this.modelnameList.join(','),
        year: (() => {
          const str = this.summaryDateStart || ''
          // 判断第一个字符是否是字母
          if (/^[a-zA-Z]/.test(str)) {
            // 首位是字母：从第2位开始取4位
            return str.substring(1, 5)
          } else {
            // 不是字母：直接取前4位
            return str.substring(0, 4)
          }
        })(),
        responseData: this.responseDataOnly
      }
      localStorage.setItem('ctqFilterInfo', JSON.stringify(body))
      // localStorage.setItem('lcdFilterUpdateTime', this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
    },
    doCTQDataList () {
      this.submit = true
      const body = {
        vendorCode: this.summaryFactory,
        partNumber: this.summaryPartNum,
        processCode: this.summaryprocess,
        stationCode: this.summarystation,
        testItemCode: this.summaryparametername,
        statisticTimeType: this.summaryperiodtype,
        statisticTimeValue: this.summaryDateStart,
        stage: 'MP'
        // year: (() => {
        //   const str = this.summaryDateStart || ''
        //   // 判断第一个字符是否是字母
        //   if (/^[a-zA-Z]/.test(str)) {
        //     // 首位是字母：从第2位开始取4位
        //     return str.substring(1, 5)
        //   } else {
        //     // 不是字母：直接取前4位
        //     return str.substring(0, 4)
        //   }
        // })()
      }
      console.info(body)
      this.$http.post(`/api/ctq/test/statistic/getStatisticData`, body).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.status === 'success') {
            const typeMap = {
              4: '實測',
              5: '實測最小',
              6: '實測最大'
            }

            const data = (res.data || []).map(item => ({
              ...item,
              typeName: typeMap[item.statisticTestItemType] || '',
              min: item.min != null ? item.min.toFixed(2) : '',
              max: item.max != null ? item.max.toFixed(2) : ''
            }))
            this.responseData = data
            this.responseDataOnly = data

            // this.responseData = res.data
            // this.responseDataOnly = res.data
            this.modelnameList = [...new Set(res.data.map(item => item.modelName))]
            this.doCTQSaveFilterInfo()
            this.doResponseColumnDefine()
            this.pagination.current.totalItems = 5
            this.pages = 1
            this.loadingView = false
          }
        })
    },

    downloadCSV () {
      if (this.doSubmitVerification()) {
        this.processingView = true
        const range = this.getSummaryDateRangeByList(this.summaryDateStart)
        const userpk = JSON.parse(localStorage.getItem('user')).userPk
        const body = {
          vendorCode: this.summaryFactory,
          partNumber: this.summaryPartNum,
          startTime: range ? range.startTime : null,
          endTime: range ? range.endTime : null,
          userPk: userpk,
          periodType: this.summaryperiodtype,
          stage: 'MP'
        }
        this.$http.post('/api/ctq/test/record/downloadDetails', body).then(res => res.data)
          .then(res => {
            this.processingView = false
            if (res.status === 'success') {
              this.snackbar = true
              this.snackbarColor = 'green'
              this.snackbarMsg = '下載成功，數據處理中...處理完成後會寄到您的郵箱中，請注意查收'
            } else {
              this.snackbar = true
              this.snackbarColor = 'red'
              this.snackbarMsg = '下載失敗，請通知系統管理員'
            }
          })
          .catch(err => {
            this.processingView = false
            this.snackbar = true
            this.snackbarColor = 'orange'
            this.snackbarMsg = err
          })
      }
    },
    getSummaryDateRangeByList (summaryDateStart) {
      if (!summaryDateStart) return null

      const item = this.contentDateList.find(
        x => x.value === summaryDateStart
      )

      if (!item) return null

      let startTime = null
      let endTime = null

      // ================= MONTH =================
      // text: "2026-01"
      const monthMatch = summaryDateStart.match(/^(\d{4})M(\d{2})$/)

      if (monthMatch) {
        const year = parseInt(monthMatch[1])
        const month = parseInt(monthMatch[2])

        startTime = new Date(year, month - 1, 1)

        // 當月最後一天
        endTime = new Date(year, month, 0)
      }

      // ================= WEEK =================
      // text: "2026 W02 (01-05 ~ 01-11)"
      const weekMatch = summaryDateStart.match(/^(\d{4})W(\d{2})$/)

      if (weekMatch) {
        const year = parseInt(weekMatch[1])

        const match = item.text.match(
          /\((\d{2}-\d{2})\s~\s(\d{2}-\d{2})\)/
        )

        if (match) {
          const [, startStr, endStr] = match

          startTime = new Date(`${year}-${startStr}`)
          endTime = new Date(`${year}-${endStr}`)
        }
      }

      return {
        startTime: this.formatDate(startTime),
        endTime: this.formatDate(endTime)
      }
    },
    uploadTestFile (event) {
      const file = event.target.files[0]
      const formData = new FormData()
      console.log(file)
      formData.append('file', file)
      // formData.append('vendorCode', this.summaryFactory)
      formData.append('vendorCode', 'JT-NJ')
      this.$http.post(
        `/api/ctq-schedule/file/uploadFile`,
        formData
      )
        .then(res => {
          const result = res.data

          const status = result.status
          const data = result.data

          if (status === 'success') {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = data
          } else {
            console.error('失败:', result.errMsg)
          }
        })
        .catch(err => {
          console.error('请求异常:', err)
        })
    },
    formatDate (date) {
      if (!date) return null

      const pad = (n) => String(n).padStart(2, '0')

      const y = date.getFullYear()
      const m = pad(date.getMonth() + 1)
      const d = pad(date.getDate())

      return `${y}-${m}-${d}`
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */

.text-center {
  text-align: center !important;
}
</style>
